import { parseJwt } from '../services/jwtParser';
import { authService } from '../services/api/authService';

export const login = (token) => ({ type: 'LOGGED_IN', payload: parseJwt(token) });
export const logout = () => (dispatch) => {
  authService.logout().then(() => dispatch({ type: 'LOGGED_OUT' }));
};
